import React from 'react';
import Loadable from 'react-loadable';
import CircularProgress from '../../../../components/CircularProgress';

const AsyncIndex = Loadable({
  loader: () => import('./ProcessList'),
  loading: () => <CircularProgress className="gx-loader-400" />,
});

export default AsyncIndex;
